module.exports = __webpack_public_path__ + "static/img/git@2x.a870d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/git@2x.png
// module id = pEc3
// module chunks = 0